export const ESTABLISHMENT_HEADER = 'x-establishment-id';

export const ESTABLISHMENT_STORAGE_KEY = 'mep_current_establishment';

declare module 'axios' {
  interface AxiosRequestConfig {
    /**
     * Condomínio desta requisição, sobrepondo o seletor global.
     *
     * A agenda do síndico consolida a carteira inteira dele, então uma ação
     * sobre um evento precisa agir no condomínio daquele evento.
     */
    establishmentId?: string;
  }
}

interface EstablishmentScopedRequest {
  establishmentId?: string;
}

/**
 * Condomínio que deve ir no header desta requisição: o pedido pela chamada, ou
 * o ativo no seletor global.
 *
 * O override vive na config da requisição, e não em `config.headers`, porque o
 * axios mescla `defaults.headers.common` em `config.headers` antes do
 * interceptor rodar — lá não há como distinguir um header explícito de um
 * herdado do seletor global.
 */
export const resolveRequestEstablishmentId = (
  requestConfig: EstablishmentScopedRequest,
  activeEstablishmentId: string | null,
): string | null => {
  const override = requestConfig.establishmentId?.trim();

  return override ? override : activeEstablishmentId;
};
